'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['', ''], ['', '']);
var _styledComponents = require('styled-components');
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var sizes = {
  laptops: [{
    reference: 'nonRetina',
    minWidth: 1200,
    maxWidth: 1600,
    ratio: 1
  }, {
    reference: 'intermediate',
    minWidth: 1024,
    maxWidth: 1440
  }, {
    reference: 'large notebook',
    minWidth: 1440,
    maxWidth: 1600
  }, {
    reference: 'retina',
    minWidth: 1200,
    maxWidth: 1600,
    ratio: 2,
    minRes: '192dpi'
  }, {
    reference: 'fullHD13Pols',
    minWidth: 1298,
    maxWidth: 1303
  }, {
    reference: 'small',
    minWidth: 1024,
    maxWidth: 1298
  }],
  ipads: [{
    reference: 'iPad 1, 2, Mini and Air',
    minWidth: 768,
    maxWidth: 1024,
    ratio: 1
  }, {
    reference: 'iPad 3, 4 and Pro 9.7',
    minWidth: 768,
    maxWidth: 1024,
    ratio: 2
  }, {
    reference: 'iPad Pro 10.5"',
    minWidth: 768,
    maxWidth: 1112,
    ratio: 2
  }, {
    reference: 'iPad Pro 12.9"',
    minWidth: 1024,
    maxWidth: 1366,
    ratio: 2
  }],
  iphones: [{
    reference: 'iPhone 4 and 4S',
    minWidth: 320,
    maxWidth: 480,
    ratio: 1
  }, {
    reference: 'iPhone 5, 5S, 5C and 5SE',
    minWidth: 320,
    maxWidth: 568,
    ratio: 2
  }, {
    reference: 'iPhone 6, 6S, 7 and 8',
    minWidth: 375,
    maxWidth: 667,
    ratio: 2
  }, {
    reference: 'iPhone 6+, 7+ and 8+',
    minWidth: 414,
    maxWidth: 736,
    ratio: 3
  }, {
    reference: 'iPhone X',
    minWidth: 375,
    maxWidth: 812,
    ratio: 3
  }],
  desktops: [{
    reference: '1280x1024',
    minWidth: 1280,
    maxHeight: 1024
  }, {
    reference: '1366x768',
    minWidth: 1366,
    maxHeight: 768
  }, {
    reference: '1440x900',
    minWidth: 1440,
    maxHeight: 900
  }, {
    reference: '1600x900',
    minWidth: 1600,
    maxHeight: 900
  }, {
    reference: '1920x1080',
    minWidth: 1920,
    maxHeight: 1080
  }]
};
var getMediaByReference = function getMediaByReference(medias, reference) {
  var findMediaByReference = medias.find(function (md) {
    return md.reference === reference;
  });
  return findMediaByReference;
};
var extractMediasByReference = function extractMediasByReference(medias, reference) {
  var media = getMediaByReference(medias, reference);
  if (media !== undefined) {
    var mediaStyles = function mediaStyles() {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var dynamicArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return '\n        @media only screen and (min-device-width: ' + media.minWidth + 'px)\n        ' + (media.maxWidth ? 'and (max-device-width: ' + media.maxWidth + 'px)' : '') + '\n        ' + (media.maxHeight ? 'and (max-height: ' + media.maxHeight + 'px)' : '') + '\n        ' + (media.minHeight ? 'and (min-height: ' + media.minHeight + 'px)' : '') + '\n        ' + (media.ratio ? 'and (-webkit-min-device-pixel-ratio: ' + media.ratio + ')' : '') + '\n        ' + (media.minRes ? 'and (min-resolution: ' + media.minRes + ')' : '') + '\n        {\n          ' + _styledComponents.css.apply(undefined, args) + '\n          ' + (0, _styledComponents.css)(_templateObject, dynamicArgs) + '\n        }\n      ';
    };
    return mediaStyles;
  }
  return function () {
    return '';
  };
};
var extractEspecifcMediaByReference = function extractEspecifcMediaByReference(medias, reference) {
  return function (dynamicArgs) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return extractMediasByReference(medias, reference).apply(undefined, [dynamicArgs].concat(args));
    };
  };
};
var getMediaParams = function getMediaParams(medias, reference) {
  var mediaParams = getMediaByReference(medias, reference);
  if (mediaParams !== undefined) {
    return mediaParams;
  }
  return {};
};
var getAllMediasStr = function getAllMediasStr(medias, dynamicArgs) {
  for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }
  var stringify = medias.reduce(function (str, media) {
    var newQuery = extractMediasByReference(medias, media.reference).apply(undefined, [dynamicArgs].concat(args));
    return str + '\n' + newQuery;
  }, '');
  return stringify;
};
var getMedias = Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = function (dynamicArgs) {
    return function () {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return getAllMediasStr.apply(undefined, [sizes[label], dynamicArgs].concat(args));
    };
  };
  return acc;
}, {});

// Iterate through the sizes and create a media template
var mediaTemplates = Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = {
    getMediaByReference: function getMediaByReference(reference) {
      return extractEspecifcMediaByReference(sizes[label], reference);
    },
    getParamsByReference: function getParamsByReference(reference) {
      return getMediaParams(sizes[label], reference);
    }
  };
  return acc;
}, {});
exports.default = {
  mediaTemplates: mediaTemplates,
  getMedias: getMedias
};